import { useEffect } from "react";
import Navbar from "@/components/Navbar.jsx";
import Footer from "@/components/Footer.jsx";
import Hero from "@/sections/Hero.jsx";
import About from "@/sections/About.jsx";
import Skills from "@/sections/Skills.jsx";
import Projects from "@/sections/Projects.jsx";
import Testimonials from "@/sections/Testimonials.jsx";
import Contact from "@/sections/Contact.jsx";
import AnimatedCursor from "@/components/AnimatedCursor.jsx";
import BackToTop from "@/components/BackToTop.jsx";
import { SITE } from "@/config";
import "@styles/index.css";
import "@styles/globals.css";
import "@styles/animations.css";

export default function App() {
  // Force default theme to dark and persist preference
  useEffect(() => {
    document.documentElement.classList.add("dark");
    try {
      localStorage.setItem("theme", "dark");
    } catch {}
  }, []);

  useEffect(() => {
    if (SITE?.title) document.title = SITE.title;
  }, []);

  return (
    <div className="min-h-screen bg-[--color-bg-dark] text-[--color-fg-dark] dark:bg-[--color-bg-dark] dark:text-[--color-fg-dark] selection:bg-[color:var(--color-primary)]/40 selection:text-black">
      <AnimatedCursor />

      <Navbar />

      <main className="snap-y snap-mandatory overflow-x-hidden">
        <section id="hero" className="snap-start">
          <Hero />
        </section>

        <section id="about" className="snap-start">
          <About />
        </section>

        <section id="skills" className="snap-start">
          <Skills />
        </section>

        <section id="projects" className="snap-start">
          <Projects />
        </section>

        {/*<section id="testimonials" className="snap-start">
          <Testimonials />
        </section>*/}

        <section id="contact" className="snap-start">
          <Contact />
        </section>
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
}